import { rruleSchema } from '@omecare/utils';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { z } from 'zod';
import http from '@/utils/http.service';

const stopRecurrenceWorkScheduleSlotResponseSchema = z.object({
  data: z.array(
    z.object({
      id: z.string().uuid(),
      rrule: rruleSchema,
    }),
  ),
});

export type StopRecurrenceWorkScheduleSlotResponse = z.infer<
  typeof stopRecurrenceWorkScheduleSlotResponseSchema
>;
export type StopRecurrenceWorkScheduleSlotPayload = {
  id: string;
  sequenceId: string;
  until: string;
  occurrenceIndex: number;
};

const stopRecurrenceWorkScheduleSlot = (
  payload: StopRecurrenceWorkScheduleSlotPayload,
) => {
  return http.workScheduleSlots
    .stopRecurrence(payload.id, {
      until: payload.until,
      occurrenceIndex: payload.occurrenceIndex,
      sequenceId: payload.sequenceId,
    })
    .then<StopRecurrenceWorkScheduleSlotResponse['data']>(({ transform }) => {
      return transform.handle({
        attributes: {
          rrule: true,
        },
        schema: stopRecurrenceWorkScheduleSlotResponseSchema,
      }).data;
    });
};

const useStopRecurrenceWorkScheduleSlotMutation = (): UseMutationResult<
  StopRecurrenceWorkScheduleSlotResponse['data'],
  Error,
  StopRecurrenceWorkScheduleSlotPayload
> => {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: stopRecurrenceWorkScheduleSlot,
    onSuccess() {
      toast.success(t('http.stop-recurrence-work-schedule-slot.success'));
    },
  });
};

export default useStopRecurrenceWorkScheduleSlotMutation;
